import { render, staticRenderFns } from "./StatsCareProgress.vue?vue&type=template&id=fc70023e&scoped=true&lang=html&"
import script from "./StatsCareProgress.vue?vue&type=script&lang=js&"
export * from "./StatsCareProgress.vue?vue&type=script&lang=js&"
import style0 from "./StatsCareProgress.vue?vue&type=style&index=0&id=fc70023e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc70023e",
  null
  
)

export default component.exports